"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.histogramSpecification = histogramSpecification;

var _transformImage = require("./transformImage");
/**
 * Applies histogram specification operation to the given image.
 * It expects the image to transform, its cumulative histogram
 * and the cumulative histogram of the target image.
 *
 * @param {RgbaImageBuffer} imgBuffer Image to transform
 * @param {CumulativeHistogram} originImageCHistogram Cumulative histogram of imgBuffer
 * @param {CumulativeHistogram} targetImageCHistogram Cumulative histogram of target image
 * @returns {RgbaImageBuffer} Transformed image
 */


function histogramSpecification(imgBuffer, srcImgInfo, targetImgInfo) {
  // Normalized the cumulative histograms so we can work with images of
  // different sizes
  var srcCHistos = srcImgInfo.cumulativeHistograms.map(function (cHisto) {
    return cHisto.map(function (count) {
      return count / srcImgInfo.pixelCount;
    });
  });
  var targetCHistos = targetImgInfo.cumulativeHistograms.map(function (cHisto) {
    return cHisto.map(function (count) {
      return count / targetImgInfo.pixelCount;
    });
  });
  var lookupTable = (0, _transformImage.createLookupTable)(function (dim) {
    return function (value) {
      var j = 255;

      while (j >= 0 && srcCHistos[dim][value] <= targetCHistos[dim][j]) {
        j -= 1;
      }

      return j;
    };
  });
  return (0, _transformImage.applyLookupTable)(imgBuffer, lookupTable);
}